import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { ArrowRightOutlined } from "@ant-design/icons";

const termConditionContent = () => {
  return (
    <section className="terms-condition-content">
      <Container>
        <div className="row">
          <div className="col-lg-12 ">
            <h2 className="main-title">Terms and Conditions</h2>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="terms-wrap">
              <div className="heading">Introduction</div>
              <div className="heading-content">
                This is to submit the terms and conditions for the usage of
                services provided by the corporate SKYCARS that define the legal
                agreement and contract between the service provider and the
                users.
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="terms-wrap">
              <div className="heading">Description Guidelines</div>

              <div className="bullet-wrap">
                <div className="bullet-heading">
                  <div className="arrow-wrap d-flex">
                    <ArrowRightOutlined />
                    <div className="bullet-heading">
                      Browsing through this website uses cookies that help to
                      store the data related to visitor preferences and history.
                    </div>
                  </div>
                </div>
              </div>

              <div className="bullet-wrap">
                <div className="bullet-heading">
                  <div className="arrow-wrap d-flex">
                    <ArrowRightOutlined />
                    <div className="bullet-heading">
                      The modification in the data regarding information and the
                      content in totality is at the discretion of the company
                      and can be modified without prior notice.
                    </div>
                  </div>
                </div>
              </div>

              <div className="bullet-wrap">
                <div className="bullet-heading">
                  <div className="arrow-wrap d-flex">
                    <ArrowRightOutlined />
                    <div className="bullet-heading">
                      The limitations, functionality errors, inefficiency in
                      timely services, accurate machinery operations, and
                      spotting the demand of the consumer, are under no warranty
                      or guarantee and we do not offer any legal liability to
                      this system.
                    </div>
                  </div>
                </div>
              </div>

              <div className="bullet-wrap">
                <div className="bullet-heading">
                  <div className="arrow-wrap d-flex">
                    <ArrowRightOutlined />
                    <div className="bullet-heading">
                      The company is not liable to meet the specific requirement
                      of the consumer of this website and any usage of
                      information and data and external material and property
                      provided by the company will be entirely upon the
                      consumer’s risk, the company does hold no liability.
                    </div>
                  </div>
                </div>
              </div>

              <div className="bullet-wrap">
                <div className="bullet-heading">
                  <div className="arrow-wrap d-flex">
                    <ArrowRightOutlined />
                    <div className="bullet-heading">
                      The external material provided in-service by the company
                      is not under modifiable or replaceable or any other
                      environment conditional liability and cannot be the source
                      of termination to the offered services.
                    </div>
                  </div>
                </div>
              </div>

              <div className="bullet-wrap">
                <div className="bullet-heading">
                  <div className="arrow-wrap d-flex">
                    <ArrowRightOutlined />
                    <div className="bullet-heading">
                      The user of this website is bound by the laws in India in
                      case of any legal dispute that may arise out of using this
                      website and accessing the services.
                    </div>
                  </div>
                </div>
              </div>

              <div className="bullet-wrap">
                <div className="bullet-heading">
                  <div className="arrow-wrap d-flex">
                    <ArrowRightOutlined />
                    <div className="bullet-heading">
                      The unofficial use of this website is strictly prohibited
                      and if found guilty, will be liable to strict punishment
                      in compliance with the rule of Law in India.
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
          <div className="col-lg-12">
            <div className="terms-wrap">
              <div className="heading">Vehicle Usage Requirement</div>

              <div className="heading-content">
              The user of our services shall be required to provide the following documents to our representatives in order to be eligible to use our vehicles,
                    </div>

              <div className="bullet-wrap">
                <div className="bullet-heading">
                  <div className="arrow-wrap d-flex">
                    <ArrowRightOutlined />
                    <div className="bullet-heading">
                    A Photo of a Valid Identity Card
                    </div>
                  </div>
                </div>
              </div>

              <div className="bullet-wrap">
                <div className="bullet-heading">
                  <div className="arrow-wrap d-flex">
                    <ArrowRightOutlined />
                    <div className="bullet-heading">
                   A Photo of a Valid Driving Licence
                    </div>
                  </div>
                </div>
              </div>

              <div className="bullet-wrap">
                <div className="bullet-heading">
                  <div className="arrow-wrap d-flex">
                    <ArrowRightOutlined />
                    <div className="bullet-heading">
                   Any Other Document, if required, over a timely update, and in accordance with the Notification updated by SKYCARS.
                    </div>
                  </div>
                </div>
              </div>

              </div>
              </div>
              </div>




              <div className="row">
                <div className="col-lg-12">
                  <div className="terms-wrap">
                    <div className="heading">Driving Licence</div>
                    <div className="heading-content">
                      In any case, if a user’s driving license is expired,
                      suspended, or revoked, the eligibility to drive the
                      SKYCARS Vehicles will be immediately terminated. The user
                      is strictly responsible for maintaining the legal license
                      agreement and obeyed by the rule of traffic violation in
                      India.
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default termConditionContent;
